// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"84":"sprints","548":"calendar","982":"sprint-calendar"}[chunkId] + "." + {"84":"7d0e8e03","548":"1c92a2dc","982":"f27c3c21"}[chunkId] + ".css";
};